import React, { FC } from 'react';
import { Control, useWatch } from 'react-hook-form';

import { formatCurrencyValue } from '@eika/currency-input';

import { GjeldKildeWeb, GjeldTypeWeb, GjeldWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { GjeldFormData } from './gjeld';

export const isBankGjeld = (kilde: GjeldKildeWeb): boolean => {
    return [GjeldKildeWeb.KERNE, GjeldKildeWeb.BANQSOFT, GjeldKildeWeb.TE_BANK, GjeldKildeWeb.TE_EBK].includes(kilde);
};

export const isKundeGjeld = (gjeld: GjeldWeb[]): boolean => {
    return !gjeld.some((g) => g.kilde !== GjeldKildeWeb.KUNDE);
};

interface Props {
    index: number;
    control: Control<GjeldFormData>;
}

const GjeldBank: FC<Props> = ({ index, control }) => {
    const { gjeld: bankgjeld } = useTranslation();
    const value = useWatch({ name: 'gjeld', control });

    return (
        <div className="info-box-white row-gap margin-bottom-small">
            <span className="title">{`${value?.[index]?.laangiver}`}</span>
            <span>
                {`${
                    value?.[index]?.gjeldType === GjeldTypeWeb.KREDITT
                        ? bankgjeld.infoKredittramme
                        : bankgjeld.infoDagensSaldo
                }: ${formatCurrencyValue(
                    (value?.[index]?.gjeldType === GjeldTypeWeb.KREDITT
                        ? value?.[index]?.kredittramme
                        : value?.[index]?.restgjeld) || 0,
                )} kr`}
            </span>
        </div>
    );
};

export default GjeldBank;
